import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DEFAULT_BRANDING } from "../../shared/branding";
import { AuthShell } from "../../shared/AuthShell";
import { useInvalidateMe } from "../../shared/hooks/useMe";
import { navigateAfterAuth } from "../../shared/returnTo";
import { Spinner } from "../../ui";

/** Google returns the browser here after the API set the session cookie. */
export function GoogleCallbackPage() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const invalidateMe = useInvalidateMe();
  const returnTo = search.get("return_to");
  useEffect(() => {
    invalidateMe().finally(() => navigateAfterAuth(returnTo, navigate));
  }, [returnTo, navigate, invalidateMe]);
  return (
    <AuthShell branding={DEFAULT_BRANDING} title="Signing you in">
      <Spinner label="Signing in" />
    </AuthShell>
  );
}
